module.exports = __webpack_public_path__ + "img/1.cccd1e26.png";